import {atom, useSetAtom} from "jotai"
import * as phoneLib from "libphonenumber-js"

// Sign-in
export const verifiedUsernameAtom = atom("")
export const verifiedUsernameTypeAtom = atom(get => {
  const username = get(verifiedUsernameAtom)
  const isPhone = phoneLib.isPossiblePhoneNumber(username)
  return isPhone ? "phone" : "email"
})
export const isUsernameVerifiedAtom = atom(get => !!get(verifiedUsernameAtom))
export const resetVerifiedUsernameAtom = atom(null, (_, set) =>
  set(verifiedUsernameAtom, ""),
)
export function useResetVerifiedUsername() {
  return useSetAtom(resetVerifiedUsernameAtom)
}

const initialMfaData = {
  cookies: [],
  state: "",
  username: "",
  password: "",
}
export const mfaDataAtom = atom(
  /** @type {Omit<import("features/mfa-confirm").TMfaConfirmParams, 'code'> & import("features/password-signin").TPasswordSignInParams} */ (
    initialMfaData
  ),
)
export const resetMfaDataAtom = atom(null, (_, set) =>
  set(mfaDataAtom, initialMfaData),
)

export const socialLoginLoadingAtom = atom(false)

export const resetSocialLoginLoadingAtom = atom(null, (_, set) =>
  set(socialLoginLoadingAtom, false),
)

export const showAutoCloseLoadingAtom = atom(
  null,
  (_, set, /** @type {{ closeAfterMS: number}} */ {closeAfterMS}) => {
    set(socialLoginLoadingAtom, true)
    setTimeout(() => {
      set(socialLoginLoadingAtom, false)
    }, closeAfterMS)
  },
)
